export default __webpack_public_path__ + "static/media/Group 878@2x.535c1cae.jpg";